import { request } from 'data/requests/request';

const manufacturerRequest = (location: string) =>
    request({
        type: 'matManufacturerResponse',
        url: 'mat/search/manufacturer',
        notApi: true,
        data: {
            location,
        },
        force: true,
    });

export default manufacturerRequest;
